import { https } from "./http";
import * as types from '../../mutation_types';

const state = {
    data:[],
    show_mult_modal:false,
    selected_items:[],
    return:{},
    storage_location:'',
    company_code:''
}

const getters = {
    data:state=>state.data,
    show_mult_modal:state=>state.show_mult_modal,
    selected_items:state=>state.selected_items,
    return:state=>state.return,
    storage_location:state=>state.storage_location,
    company_code:state=>state.company_code
}

const actions = {
    addItems({commit}){
        $.each(state.selected_items,(key,value)=>{
            let details = {
                matnr:value.matnr,
                barcode:value.barcode,
                desc:value.description,
                qty:0,
                unit:value.unit,
                price:value.price
            };
            commit(types.PRET_DATA,details);
        })
        commit(types.PRET_MULT_SEARCH_ITEMS,[]);
    },
    async storeItems({commit}){
        let form_data = new FormData();
        form_data.append('items',JSON.stringify(state.data));
        form_data.append('company_code',state.company_code);
        form_data.append('storage_location',state.storage_location);
        let uri = `purchase-return-header`;
        await https().post(uri,form_data).then(response=>{
            commit(types.PRET_RETURN,response.data);
        }).catch(error=>{
            console.log(error);
            let data = {
                icon:'error',
                message:'Posting Purchase Return encountered an Error.'
            }
            commit(types.PRET_RETURN,data);
        })
    },
    async storeItemsAsDraft({commit}){
        let form_data = new FormData();
        form_data.append('items',JSON.stringify(state.data));
        form_data.append('company_code',state.company_code);
        form_data.append('storage_location',state.storage_location);
        let uri = `purchase-return-draft-header`;
        await https().post(uri,form_data).then(response=>{
            commit(types.PRET_RETURN,response.data);
        }).catch(error=>{
            console.log(error);
            let data = {
                icon:'error',
                message:'Saving Purchase Return as Draft encountered an Error.'
            }
            commit(types.PRET_RETURN,data);
        })
    }
}

const mutations = {
    [types.PRET_DATA](state,data){
        state.data.push(data);
    },
    [types.PRET_SHOW_MULT_SEARCH_MODAL](state){
        state.show_mult_modal = !state.show_mult_modal;
    },
    [types.PRET_MULT_SEARCH_ITEMS](state,data){
        state.selected_items = data;
    },
    [types.PRET_RETURN](state,data){
        state.return = data;
    },
    [types.PRET_STORLOC](state,data){
        state.storage_location = data;
    },
    [types.PRET_COMPCODE](state,data){
        state.company_code = data;
    },
    [types.PRET_RESET_DATA](state){
        state.data = [];
    }
}

export {
    state,getters,actions,mutations
}